"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = void 0;
exports.isBrowser = function () {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};
//# sourceMappingURL=is-browser.js.map